import api from "@/lib/api";

export const IK_ENDPOINT = "https://ik.imagekit.io/trainingbasket1";

let cachedEndpoint = IK_ENDPOINT;
let pending = null;

export function getIkEndpoint() {
  if (!pending) {
    pending = api.get("/media/config").then((r) => {
      const ep = (r.data.endpoint || "").replace(/\/$/, "");
      if (ep) cachedEndpoint = ep;
      return cachedEndpoint;
    }).catch(() => cachedEndpoint);
  }
  return Promise.resolve(cachedEndpoint);
}

export function ikTransform(url, width, endpoint) {
  const ep = endpoint ?? cachedEndpoint;
  if (!ep || !url || !url.startsWith(ep)) return url;
  return `${ep}/tr:w-${width},q-80,f-auto${url.slice(ep.length)}`;
}

export function buildSrcSet(url, endpoint, widths = [400, 800, 1200]) {
  const ep = endpoint ?? cachedEndpoint;
  if (!ep || !url || !url.startsWith(ep)) return undefined;
  return widths.map((w) => `${ikTransform(url, w, ep)} ${w}w`).join(", ");
}

export const slugify = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "image";

export const fmtBytes = (n) => (!n ? "—" : n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export async function sha256OfFile(file) {
  const buf = await file.arrayBuffer();
  const hash = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hash)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
